import AutoplayController from "~/lib/autoplay_controller"
import { replay } from "~/lib/motion"

// Clicking colors and toggles restyles the popup preview live
export default class extends AutoplayController {
  static targets = ["swatch", "toggle", "preview", "continue"]

  reset() {
    this.pick(this.swatchTargets[0])
    this.toggleTarget.classList.remove("is-on")
    this.continueTarget.hidden = true
  }

  async play(wait) {
    for (const swatch of [this.swatchTargets[1], this.swatchTargets[2]]) {
      await wait(700)
      await this.click(swatch, wait)
      this.pick(swatch)
    }
    await wait(700)
    await this.click(this.toggleTarget, wait)
    this.toggleTarget.classList.add("is-on")
    this.continueTarget.hidden = false
    replay(this.continueTarget, "is-pop")
  }

  pick(swatch) {
    this.swatchTargets.forEach((s) => s.classList.toggle("is-selected", s === swatch))
    this.previewTarget.style.setProperty("--accent", swatch.dataset.color)
  }
}
